import useMixPanel, { initMixPanel, getEventBaseParams } from "./mixPanel";
import { UMengTrack, UMengTrackInitScript } from "./umengTrack";

export const initTracker = ({
  enableMixpanel = true,
  enableUMeng = true,
} = {}) => {
  console.log("initTracker");
  if (enableUMeng) {
    UMengTrackInitScript();
  }
  if (enableMixpanel) {
    initMixPanel();
  }
};

const useTrackSend = ({ enableMixpanel = true, enableUMeng = true } = {}) => {
  const { trackEvent: trackMixPanelEvent } = useMixPanel();

  const trackTypeMapping = {
    clickEvent: "clickEvent",
    pageVisit: "pageVisit",
  };

  // 页面访问上报
  const pageVisitSend = (params) => {
    params = {
      ...params,
      trackParams: {
        ...params.trackParams,
        ...getEventBaseParams(),
      },
    };
    // _handleTrack({
    //   ...params,
    //   trackMessage: intl.formatMessage(
    //     { id: "pageVisit" },
    //     { page: params.trackMessage }
    //   ),
    //   trackType: trackTypeMapping.pageVisit,
    //   trackEventName: trackTypeMapping.pageVisit,
    // });

    if (enableMixpanel) {
      trackMixPanelEvent(trackTypeMapping.pageVisit, {
        ...params.trackParams,
      });
    }
  };

  const trackSend = (params) => {
    params = {
      ...params,
      trackParams: {
        ...params.trackParams,
        ...getEventBaseParams(),
      },
    };
    if (enableMixpanel) {
      trackMixPanelEvent(params.trackEventName, {
        ...params.trackParams,
      });
    }
    if (enableUMeng) {
      UMengTrack([
        "_trackEvent",
        "alayanew",
        params.trackEventName,
        JSON.stringify(params.trackParams),
        params.trackParams?.value,
      ]);
      // window._czc?.push([
      //   "_trackEvent",
      //   "alayanew",
      //   params.trackEventName,
      //   JSON.stringify(params.trackParams),
      //   params.trackParams?.value,
      // ]);
    }
  };

  return {
    trackSend,
    pageVisitSend,
  };
};

export const trackSend = (params) => {
  return useTrackSend().trackSend(params);
};

export default useTrackSend;
